import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

import MainLayout from "./Layout/MainLayout";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    // user is not authenticated
    return <Navigate to="/" />;
  }
  return <MainLayout>{children}</MainLayout>;
};
